import { render, staticRenderFns } from "./BannerProyectos.vue?vue&type=template&id=5d7c2c4e&scoped=true"
import script from "./BannerProyectos.vue?vue&type=script&lang=js"
export * from "./BannerProyectos.vue?vue&type=script&lang=js"
import style0 from "./BannerProyectos.vue?vue&type=style&index=0&id=5d7c2c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c2c4e",
  null
  
)

export default component.exports